import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css, styled } from 'styled-components';
import { Box } from "../../box/src";
import { Description } from './components/Description';
import { EmbedConsentGuard } from './components/EmbedConsentGuard';
import { Loading } from './components/Loading';
import { Remove } from './components/Remove';
import { RichMedia } from './components/RichMedia';
import { Thumbnail } from './components/Thumbnail';
import { VideoMedia } from './components/VideoMedia';
import { EMBED_TYPES } from './constants';
import { borderRadius, extractWebsite, normalizeType } from './utils';
const LoadingWrapper = ({ onClose, roundCorners, withDescription, }) => (_jsxs(Wrapper, { "$rounded": roundCorners, "data-testid": "ds-embed", children: [_jsx(Loading, { withDescription: withDescription }), onClose && _jsx(Remove, { onClick: onClose })] }));
const RichEmbed = ({ embed, href, isRichEmbed, mediaAspectRatio, renderEmptyPreview, }) => isRichEmbed ? (_jsx(RichMedia, { aspectRatio: mediaAspectRatio, embed: embed })) : (_jsx(Thumbnail, { aspectRatio: mediaAspectRatio, embed: embed, href: href, renderEmptyPreview: renderEmptyPreview }));
export const Embed = ({ autoplay = false, embed, interactive = true, isDisabled = false, isLoading = false, linkUrl, mediaAspectRatio, onClose, onVideoPlay, renderEmptyPreview, roundCorners = 'small', withDescription = true, withUserConsent, }) => {
    if (isLoading || !embed) {
        return (_jsx(LoadingWrapper, { onClose: onClose, roundCorners: roundCorners, withDescription: withDescription }));
    }
    const { description, html, provider_name: providerUrl, thumbnail_url: thumbnailUrl, title, url, } = embed;
    const href = linkUrl !== null && linkUrl !== void 0 ? linkUrl : url;
    const type = normalizeType(embed.type);
    const isVideoEmbed = type === EMBED_TYPES.VIDEO && html && interactive;
    const isRichEmbed = type === EMBED_TYPES.RICH && html && interactive;
    const hasMedia = isVideoEmbed ||
        isRichEmbed ||
        renderEmptyPreview ||
        thumbnailUrl ||
        (type === EMBED_TYPES.PHOTO && url);
    return (_jsxs(Wrapper, { "$rounded": roundCorners, "data-testid": "ds-embed", children: [_jsxs(WrapperInner, { "$isDisabled": isDisabled, children: [hasMedia && (_jsx(EmbedConsentGuard, { embed: embed, isActive: withUserConsent && interactive && !isDisabled, children: isVideoEmbed ? (_jsx(VideoMedia, { aspectRatio: mediaAspectRatio, autoplay: autoplay, embed: embed, onVideoPlay: onVideoPlay, renderEmptyPreview: renderEmptyPreview })) : (_jsx(RichEmbed, { embed: embed, href: href, isRichEmbed: isRichEmbed, mediaAspectRatio: mediaAspectRatio, renderEmptyPreview: renderEmptyPreview })) })), withDescription && (_jsx(Description, { description: description, href: href, providerUrl: extractWebsite(providerUrl), title: title, withTitleSpacer: !hasMedia && Boolean(onClose) }))] }), onClose && _jsx(Remove, { onClick: onClose, title: title })] }));
};
const Wrapper = styled(Box).attrs({
    bg: 'smoke',
    flex: 1,
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
}) `
  overflow: hidden;
  border-radius: ${({ $rounded, theme }) => borderRadius({ $rounded, theme })};
`;
const WrapperInner = styled(Box).attrs({
    flex: 1,
    flexDirection: 'column',
    width: '100%',
}) `
  ${({ $isDisabled }) => $isDisabled &&
    css `
      opacity: 0.7;
      pointer-events: none;
    `}
`;
//# sourceMappingURL=Embed.js.map